export default __webpack_public_path__ + "static/lozenge-dropdown-dont-2-light-c860ade4829ac3304759eccf6af665ff696a23d5120696da7529ef868381bfa2.png";